export const OverviewAccuracyPercentRanges = [
  {
    start: 1,
    end: 39,
    color: "#FF3B30"
  },
  {
    start: 40,
    end: 59,
    color: "#FF810A"
  },
  {
    start: 60,
    end: 100,
    color: "#34C768"
  }
];
